const textSpacer = " ";
export {
  textSpacer
};
